var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footerButton"}},[_c('button',{class:{ active: _vm.active },attrs:{"disabled":!_vm.active},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }